import React from "react"

import { Redirect, withRouter } from "react-router-dom"
import { Form, Icon, Input, Button, Tooltip, message, Typography } from 'antd'
import { Auth } from "aws-amplify"

import LoginBase from './LoginBase'

import { connect } from "react-redux"
import { allState as mapStateToProps, allDispatch as mapDispatchToProps } from "../../Redux/Selectors"
const { Text } = Typography;
const queryString = require('query-string');

class ConfirmEmailForm extends React.Component{

    async onSubmit(e) {
        e.preventDefault()
        this.props.form.validateFieldsAndScroll({first: true}, (err, values) => {
            if (!err) {
                Auth.confirmSignUp(
                    values.email.toLowerCase().replace(/\s+/g, ''),
                    values.confirmation_code
                )
                .then(data => {
                    console.log(data)
                    const url = (this.props.location.pathname === '/mp-confirm-email') ? '/login-mp?' : '/login?'
                    this.props.history.push(url + queryString.stringify({email:values.email.toLowerCase().replace(/\s+/g, '')}))
                })
                .catch(error => {
                    switch (error.code){

                        case 'CodeDeliveryFailureException':
                            message.error('No pudimos enviar el código de verificación al correo indicado. Por favor, reintenta con otro mail',5)
                            break;

                        case 'CodeMismatchException':
                            message.error('Codigo de verificación invalido. Por favor, revisa tu mail')
                            break;

                        case 'LimitExceededException':
                            message.error('Demasiadas reintentos. Por favor, vuelve a probar más tarde')
                            break;

                        default:
                            message.error('No pudimos procesar tu solicitud. Por favor, reintenta mas tarde. Codigo: '+error.code,5)
                            break;
                    }
                })
            }
        })
    }

    async onSend(e) {
        e.preventDefault()
        this.props.form.validateFields(["email"])
        if (this.props.form.getFieldError("email") === undefined) {
            Auth.resendSignUp(
                this.props.form.getFieldValue("email")
            )
            .then(data => {
                message.success("Código reenviado correctamente")
            })
            .catch(error => {
                message.error('Ocurrio un error. Contacta a los administradores - codigo: '+error.code)
            })
        }
    }

    render() {

        const { getFieldDecorator } = this.props.form;

        const parsed = queryString.parse(this.props.location.search)
        let email = "email" in parsed ? parsed.email : ""

        if (this.props.login.fechingStatus === true){
            return null;
        }
        else if (this.props.login.calling === false && this.props.login.auth === true ) {
            return <Redirect to="/" />;
        }
        else {
            return (
                <LoginBase title="Confirmar email">
                    <Text strong style={{ fontSize: '14px', fontWeight: "" }}>Te enviamos a tu email el código de verificación de seis digitos</Text>
                    <Form
                        onSubmit={(e)=>this.onSubmit(e)}
                        hideRequiredMark={true}
                        style={{margin:"10px"}}
                    >
                        <Form.Item>
                        {
                            getFieldDecorator('email', {
                                rules: [
                                    {
                                        type: 'email',
                                        message: 'Email válido requerido!',
                                    },
                                    {
                                        required: true,
                                        message: 'Email requerido',
                                    },
                                ],
                                initialValue: email
                            })(<Input
                                    prefix={<Icon type="mail" />}
                                    placeholder="E-mail"
                                    suffix={
                                        <Tooltip title="Ingrese su email">
                                            <Icon type="info-circle" />
                                        </Tooltip>
                                    }
                                    autoComplete="email"
                                    //autoFocus={email===""}
                                />)
                        }
                        </Form.Item>
                        <Form.Item>
                        {
                            getFieldDecorator('confirmation_code', {
                                rules: [
                                    {
                                        required: true,
                                        message: 'Código de verificación requerido',
                                    },
                                ]
                            })(<Input
                                    prefix={<Icon type="unlock" />}
                                    placeholder="Codigo de verificación"
                                    suffix={
                                        <Tooltip title="Ingrese el código enviado a su mail">
                                            <Icon type="info-circle" />
                                        </Tooltip>
                                    }
                                    autoComplete="off"
                                    //autoFocus={email!==""}
                                />)
                        }
                        </Form.Item>
                        <Form.Item>
                            <Button.Group>
                                <Button
                                    onClick={(e)=>this.onSubmit(e)}
                                    type="primary"
                                    htmlType="submit"
                                    loading={this.props.login.calling}
                                >
                                    Confirmar email
                                </Button>
                                <Button
                                    onClick={(e)=>this.onSend(e)}
                                    htmlType="submit"
                                    loading={this.props.login.calling}
                                >
                                    Reenviar código
                                </Button>
                            </Button.Group>
                        </Form.Item>
                    </Form>
                </LoginBase>
            )
        }
    }
}

const ConfirmEmail = Form.create({ name: 'confirm-email' })(ConfirmEmailForm);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ConfirmEmail));
